import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { createPortal } from "react-dom";
import { Manager, Popper, Reference } from "react-popper";
import { TooltipArrow, TooltipContent, TooltipWrapper } from "./styles";
/**
 * Tooltip component that displays content above the wrapped element
 * Supports controlled mode (isOpen prop) or hover mode (default)
 */
export const Tooltip = ({ children, content, isOpen, placement = "top-start", }) => {
    const [isHovered, setIsHovered] = useState(false);
    // Use isOpen if provided, otherwise use hover state
    const shouldShow = isOpen !== undefined ? isOpen : isHovered;
    return (_jsxs(Manager, { children: [_jsx(Reference, { children: ({ ref }) => (_jsx(TooltipWrapper, { ref: ref, onMouseEnter: () => setIsHovered(true), onMouseLeave: () => setIsHovered(false), children: children })) }), shouldShow &&
                createPortal(_jsx(Popper, { placement: placement, strategy: "fixed", modifiers: [
                        {
                            name: "offset",
                            options: {
                                offset: [0, 8],
                            },
                        },
                        {
                            name: "preventOverflow",
                            options: {
                                padding: 8,
                            },
                        },
                        {
                            name: "flip",
                            enabled: true,
                        },
                        {
                            name: "arrow",
                            options: {
                                padding: 2,
                            },
                        },
                    ], children: ({ ref, style, placement: popperPlacement, arrowProps }) => (_jsxs(TooltipContent, { ref: ref, style: style, "data-placement": popperPlacement, children: [content, _jsx(TooltipArrow, { ref: arrowProps.ref, style: arrowProps.style, "data-placement": popperPlacement })] })) }), document.body)] }));
};
